import { useMemo } from "react";
import { useArcGenerationSessionStore } from "../stores/arcGenerationSessionStore";
import { useEphemeralCoachingWs } from "./useEphemeralCoachingWs";

/**
 * Hook for making arc generation WebSocket requests.
 * Thin wrapper over the generic ephemeral WS hook.
 */
export function useArcGenerationRequest() {
  const processFrame = useArcGenerationSessionStore((s) => s.processFrame);
  const setActiveRequestId = useArcGenerationSessionStore((s) => s.setActiveRequestId);
  const abortStreamingWithReason = useArcGenerationSessionStore(
    (s) => s.abortStreamingWithReason,
  );

  const callbacks = useMemo(
    () => ({
      processFrame,
      setActiveRequestId,
      // Routes WS-state-only terminations (timeout, ws error,
      // server crash mid-stream) to the store so the spinner +
      // optimistic ``submission.pending`` don't get stuck when no
      // terminal frame ever arrives.
      onStreamTerminated: abortStreamingWithReason,
    }),
    [processFrame, setActiveRequestId, abortStreamingWithReason],
  );

  const { sendAction, cancelRequest } = useEphemeralCoachingWs(callbacks);

  return { sendArcGenAction: sendAction, cancelRequest };
}
